import React, { useEffect, useState } from "react";

import { Box, Fade } from "@mui/material";
import * as Styled from "./styled";

import useTransactions from "./hooks/useTransactions";

const Configuration = {
  timeout: 5000,

  transaction: {
    success: {
      title: "Congratulations! You’ve minted the land 🎉",
      severity: "success",
    },
    failed: {
      title: "Error: Something went wrong 😕",
      severity: "error",
    },
  },
};

function Notifications() {
  const [display, setDisplay] = useState(false);
  const [notification, setNotification] = useState(null);
  useEffect(() => {
    if (!notification) return;

    setDisplay(true);
    setTimeout(() => setDisplay(false), Configuration.timeout);
  }, [notification, setDisplay]);

  const transaction = useTransactions();
  useEffect(() => {
    if (!transaction) return;

    setNotification({
      title: Configuration.transaction[transaction.status].title,
      severity: Configuration.transaction[transaction.status].severity,
      onClose: () => setDisplay(false),
    });
  }, [transaction, setNotification]);

  return (
    <>
      {notification && (
        <Fade in={display}>
          <Box>
            <Styled.Transaction severity={notification.severity} onClose={notification.onClose}>
              {notification.title}
            </Styled.Transaction>
          </Box>
        </Fade>
      )}
    </>
  );
}

export default Notifications;
